// extracted by mini-css-extract-plugin
export default {"container":"Creator_container__yAh0Z","avatar":"Creator_avatar__PbooX","text":"Creator_text__VxfNG","span":"Creator_span__ZNfCp"};